export default __webpack_public_path__ + "static/media/photo--lg--135.6ee20cce.jpg";